// Tokens de color del dashboard — ÚNICA fuente para KPI y charts.
// Sincronizados con los tokens SCSS de style.scss ($primary/$success/$warning/$info)
// y con los del Login (botón primario). NO cambiar aquí sin cambiar el SCSS.
export const dashboardColors = {
  // Azul institucional REAL de SiprinMax (botón Login, KPI Clientes)
  primary: '#078bcd',
  // Verde institucional (KPI Nuevos, serie Nuevos)
  success: '#1e9e6a',
  // Ámbar institucional (serie Puntaje)
  warning: '#e8a013',
  // Azul claro institucional (KPI Renovados, serie Renovaciones)
  info: '#078bcd',
}
